import { getAnnualClock } from 'actions/annualClock';
import { getHomePage } from 'actions/home';
import AIAssistantBanner from 'components/Banners/AIAssistantBanner';
import GlobalErrorLayout from 'components/Error/GlobalErrorLayout';
import LoadingSpinner from 'components/Loaders/LoadingSpinner';
import { useFeatureFlags } from 'constants/index';
import useSelector from 'hooks/useSelector';
import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingState } from 'types/api';
import { LoadingSpinnerSize } from 'types/loadingSpinner';

import { getRecommends } from '../../actions/recommends';
import AnnualClock from './AnnualClock/AnnualClock';
import CaseManagement from './CaseMangement';
import EmployeeJourney from './EmployeeJourney/EmployeeJourney';
import styles from './Home.module.scss';
import Todo from './Todo';

const RelevantLink = lazy(() => import("./RelevantLink")); // not shown to the user right away
const Home = () => {
    const dispatch = useDispatch();
    const { employeeJourney } = useFeatureFlags();
    const home = useSelector((state) => state.home);
    const recommends = useSelector((state) => state.recommends);
    const annualClock = useSelector((state) => state.annualClock);
    useEffect(() => {
        home.status !== LoadingState.loading && dispatch(getHomePage());
        recommends.status !== LoadingState.loading && dispatch(getRecommends());
        annualClock.status !== LoadingState.loading && dispatch(getAnnualClock());
    }, []);
    const recommendsLoading = !recommends.data && recommends.status === LoadingState.loading;
    const homeLoading = !home.data && home.status === LoadingState.loading;
    const annualClockLoading = !annualClock.data && annualClock.status === LoadingState.loading;
    const recommendsError = recommends.status === LoadingState.failure;
    const homeError = home.status === LoadingState.failure;
    const annualClockError = annualClock.status === LoadingState.failure;

    if (recommendsError || homeError || annualClockError) {
        return <GlobalErrorLayout />;
    }

    if (homeLoading || recommendsLoading || annualClockLoading) {
        return <LoadingSpinner size={LoadingSpinnerSize.large} absoluteCenter />;
    }
    if (!home.data) {
        return null;
    }
    return (
        <Suspense fallback={<div />}>
            <div className={styles["home-page"]}>
                <AIAssistantBanner />
                <CaseManagement />
                {employeeJourney && <EmployeeJourney />}
                <div>
                    <div className={styles["home-page--main"]}>
                        <Todo />
                        <AnnualClock categories={annualClock.data!.categories} />
                    </div>
                </div>
                <RelevantLink />
            </div>
        </Suspense>
    );
};

export default Home;
